import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-orientation-warning',
  templateUrl: './orientation-warning.component.html',
  styleUrls: ['./orientation-warning.component.scss'],
})
export class OrientationWarningComponent implements OnInit {
  warningContainerDisplayProperty = 'none';

  constructor(private renderer: Renderer2) {}

  @HostListener('window:resize')
  onResize() {
    this.shouldShowOrientationWarning();
  }

  ngOnInit() {
    this.shouldShowOrientationWarning();
  }

  /**
   * Function that evaluates whether or not to show the warning
   * This would be called when the component initalizes as well as when the
   * size of the screen changes.
   */
  private shouldShowOrientationWarning() {
    /**
     * Set the container display property and pointer events of the body based
     * on whether the width exceeds the height of the screen
     */
    if (window.innerWidth > window.innerHeight) {
      this.warningContainerDisplayProperty = 'flex';
      this.renderer.setStyle(document.body, 'pointer-events', 'none');
    } else {
      this.warningContainerDisplayProperty = 'none';
      this.renderer.removeStyle(document.body, 'pointer-events');
    }
  }
}
